import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageAIAgent({vulns}){
  var T=React.useContext(ThemeCtx).T;
  var _msgs=useState([]); var msgs=_msgs[0]; var setMsgs=_msgs[1];
  var _input=useState(""); var input=_input[0]; var setInput=_input[1];
  var _loading=useState(false); var loading=_loading[0]; var setLoading=_loading[1];
  var _prompts=useState([]); var prompts=_prompts[0]; var setPrompts=_prompts[1];
  var _status=useState(null); var status=_status[0]; var setStatus=_status[1];
  var _tab=useState("chat"); var tab=_tab[0]; var setTab=_tab[1];
  var endRef=useRef(null);

  useEffect(function(){
    api.get("/agent/prompts").then(setPrompts).catch(function(){});
    api.get("/agent/status").then(setStatus).catch(function(){});
  },[]);

  useEffect(function(){
    if(endRef.current) endRef.current.scrollIntoView({behavior:"smooth"});
  },[msgs]);

  var addMsg=function(role,content,label){
    setMsgs(function(p){return p.concat([{role,content,label,ts:new Date()}]);});
  };

  var sendChat=async function(){
    if(!input.trim()||loading) return;
    var userMsg=input.trim(); setInput(""); setLoading(true);
    addMsg("user",userMsg);
    try{
      var history=msgs.concat([{role:"user",content:userMsg}]).map(function(m){return{role:m.role==="user"?"user":"assistant",content:m.content};});
      var d=await api.post("/agent/chat",{messages:history});
      addMsg("assistant",d.reply);
    }catch(e){addMsg("assistant","Error: "+e.message);}
    setLoading(false);
  };

  var runQuick=async function(name,label){
    setLoading(true); setTab("chat");
    addMsg("user","[Quick action: "+label+"]");
    try{
      var d=await api.post("/agent/quick",{name});
      addMsg("assistant",d.reply,label);
    }catch(e){addMsg("assistant","Error: "+e.message);}
    setLoading(false);
  };

  var catColors={"analysis":"#A100FF","communication":"#3b82f6","planning":"#22c55e"};
  var cats=[...new Set(prompts.map(function(p){return p.category;}))];

  var MsgBubble=function(props){
    var m=props.m;
    var isUser=m.role==="user";
    var isQuickLabel=isUser&&m.content.startsWith("[Quick action:");
    return React.createElement("div",{style:{display:"flex",gap:10,marginBottom:12,flexDirection:isUser?"row-reverse":"row",alignItems:"flex-start"}},
      React.createElement("div",{style:{
        width:28,height:28,borderRadius:"50%",flexShrink:0,
        background:isUser?"#A100FF":"#000",
        border:"2px solid "+(isUser?"#A100FF":"#A100FF44"),
        display:"flex",alignItems:"center",justifyContent:"center",
        fontSize:12,fontWeight:700,color:"#fff",
      }},isUser?"U":">"),
      React.createElement("div",{style:{
        maxWidth:"75%",
        background:isUser?"#A100FF18":T.card,
        border:"1px solid "+(isUser?"#A100FF44":T.border),
        padding:"10px 14px",
        fontSize:13,color:T.text,lineHeight:1.7,
      }},
        m.label&&React.createElement("div",{style:{fontSize:10,color:"#A100FF",fontWeight:700,letterSpacing:1,textTransform:"uppercase",marginBottom:6}}),
        m.label,
        isQuickLabel
          ? React.createElement("div",{style:{fontSize:12,color:T.text3,fontStyle:"italic"}},m.content.replace("[Quick action: ","").replace("]","")+" — running...")
          : React.createElement("pre",{style:{fontFamily:"inherit",whiteSpace:"pre-wrap",wordBreak:"break-word",margin:0}},m.content),
        React.createElement("div",{style:{fontSize:9,color:T.text3,marginTop:4,textAlign:isUser?"right":"left"}},
          m.ts?m.ts.toLocaleTimeString():""
        )
      )
    );
  };

  return React.createElement("div",{style:{display:"flex",height:"calc(100vh - 100px)",gap:0,overflow:"hidden"}},

    // Left — quick actions panel
    React.createElement("div",{style:{width:260,background:T.card,borderRight:"1px solid "+T.border,display:"flex",flexDirection:"column",flexShrink:0,overflow:"auto"}},
      React.createElement("div",{style:{padding:"14px 16px",borderBottom:"1px solid "+T.border}},
        React.createElement("div",{style:{fontSize:12,fontWeight:700,color:"#A100FF",letterSpacing:1,textTransform:"uppercase",marginBottom:4}},"AI Agents"),
        React.createElement("div",{style:{fontSize:11,color:T.text3}},
          status?( status.configured?"Connected · "+status.provider:"Not configured"):""
        ),
        !status?.configured&&React.createElement("div",{style:{fontSize:11,color:T.warning,marginTop:4}},"Configure in API Config →")
      ),
      cats.map(function(cat){
        var catPrompts=prompts.filter(function(p){return p.category===cat;});
        return React.createElement("div",{key:cat,style:{padding:"10px 12px"}},
          React.createElement("div",{style:{fontSize:9,color:T.text3,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase",marginBottom:8,paddingLeft:4}},cat),
          catPrompts.map(function(pr){
            return React.createElement("button",{key:pr.name,
              onClick:function(){runQuick(pr.name,pr.label);},
              disabled:loading,
              style:{
                width:"100%",display:"flex",alignItems:"center",gap:8,
                padding:"9px 10px",marginBottom:3,
                background:"transparent",border:"1px solid "+T.border,
                color:T.text2,cursor:"pointer",fontSize:12,textAlign:"left",
                transition:"all .1s",opacity:loading?0.5:1,
              },
              onMouseEnter:function(e){e.currentTarget.style.background="#A100FF18";e.currentTarget.style.borderColor="#A100FF44";e.currentTarget.style.color="#A100FF";},
              onMouseLeave:function(e){e.currentTarget.style.background="transparent";e.currentTarget.style.borderColor=T.border;e.currentTarget.style.color=T.text2;}
            },
              React.createElement("span",{style:{fontSize:15}},pr.icon),
              React.createElement("span",{style:{fontSize:12,fontWeight:500}},pr.label)
            );
          })
        );
      }),
      React.createElement("div",{style:{padding:"12px 16px",borderTop:"1px solid "+T.border,marginTop:"auto"}},
        React.createElement("button",{onClick:function(){setMsgs([]);},style:{width:"100%",padding:"7px",background:"transparent",border:"1px solid "+T.border,color:T.text3,cursor:"pointer",fontSize:11,letterSpacing:.5}},
          "Clear conversation"
        )
      )
    ),

    // Right — chat area
    React.createElement("div",{style:{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}},

      // Chat header
      React.createElement("div",{style:{padding:"12px 16px",borderBottom:"1px solid "+T.border,background:T.card,display:"flex",alignItems:"center",gap:10}},
        React.createElement("div",{style:{width:8,height:8,borderRadius:"50%",background:status?.configured?"#22c55e":"#f59e0b"}}),
        React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text}},
          "AVTA AI Agent"
        ),
        React.createElement("div",{style:{fontSize:11,color:T.text3,marginLeft:"auto"}},
          "Powered by ",status?.provider||"AI"," · Full vulnerability context"
        )
      ),

      // Messages
      React.createElement("div",{style:{flex:1,overflowY:"auto",padding:"16px",display:"flex",flexDirection:"column"}},
        msgs.length===0&&React.createElement("div",{style:{textAlign:"center",color:T.text3,marginTop:40}},
          React.createElement("div",{style:{fontSize:32,marginBottom:12}},">"),
          React.createElement("div",{style:{fontSize:15,fontWeight:600,color:T.text,marginBottom:8}}),"AVTA AI Agent",
          React.createElement("div",{style:{fontSize:13,color:T.text3,maxWidth:360,margin:"0 auto",lineHeight:1.7}},
            "Select a quick action from the left panel or type a question below.",React.createElement("br",null),
            "I have full visibility into all vulnerabilities, SLA status, and team workload."
          ),
          React.createElement("div",{style:{display:"flex",flexWrap:"wrap",gap:8,justifyContent:"center",marginTop:24}},
            ["Which vulns are overdue?","Draft SLA reminder for all owners","What is the risk summary this week?","Show pod workload breakdown"].map(function(hint){
              return React.createElement("button",{key:hint,onClick:function(){setInput(hint);},
                style:{background:"#A100FF11",border:"1px solid #A100FF33",color:"#A100FF",padding:"6px 12px",fontSize:12,cursor:"pointer"}},
                hint
              );
            })
          )
        ),
        msgs.map(function(m,i){return React.createElement(MsgBubble,{key:i,m:m});}),
        loading&&React.createElement("div",{style:{display:"flex",gap:10,marginBottom:12,alignItems:"flex-start"}},
          React.createElement("div",{style:{width:28,height:28,borderRadius:"50%",background:"#000",border:"2px solid #A100FF44",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"#fff"}},">"),
          React.createElement("div",{style:{background:T.card,border:"1px solid "+T.border,padding:"10px 14px"}},
            React.createElement("div",{style:{display:"flex",gap:4,alignItems:"center"}},
              [0,1,2].map(function(i){return React.createElement("div",{key:i,style:{width:6,height:6,borderRadius:"50%",background:"#A100FF",animation:"pulse 1.4s ease-in-out "+(i*0.2)+"s infinite",opacity:.4}});})
            )
          )
        ),
        React.createElement("div",{ref:endRef})
      ),

      // Input
      React.createElement("div",{style:{padding:"12px 16px",borderTop:"1px solid "+T.border,background:T.card,display:"flex",gap:8}},
        React.createElement("input",{
          value:input,
          onChange:function(e){setInput(e.target.value);},
          onKeyDown:function(e){if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendChat();}},
          placeholder:"Ask anything about vulnerabilities, owners, SLA status...",
          style:{flex:1,padding:"10px 14px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:13,outline:"none"},
          disabled:loading,
        }),
        React.createElement("button",{onClick:sendChat,disabled:loading||!input.trim(),style:{background:"#A100FF",color:"#fff",border:"none",padding:"10px 20px",cursor:"pointer",fontSize:13,fontWeight:700,letterSpacing:.5,opacity:loading?0.6:1}},
          "Send >"
        )
      )
    )
  );
}

